<template>
    <div>
        <SkeletonBase
            hasTitle
            :content="2"
        />
        <SkeletonBase
            hasTitle
            :content="2"
            has-divided
            has-button
        />
        <SkeletonBase
            hasTitle
            :content="1"
            has-divided
            has-button
        />
        <SkeletonBase
            :content="2"
        />
    </div>
</template>

<script>
import SkeletonBase from '@/components/skeletons/SkeletonBase.vue';

export default {
    components: {
        SkeletonBase
    },
};
</script>
